module.exports = __webpack_public_path__ + "static/media/fast_roulette.2cc108a2.mp3";